import React from 'react';
import { Field } from 'redux-form';
import { CovExclCheckbox } from './components/index';
import SelectCampaigns from '../LeisureTravelForm/Components/SelectCampaigns/SelectCampaigns.jsx';
import { InfoButton } from '../../../../common/components/index';
import CheckboxUnlabeled from '../../../../common/components/ReduxFormField/CheckboxUnlabeled';
import { hasRole } from '../../../auth/redux/authActions';
import { getBrokerId, isBroker } from '../../../auth/redux/authActions';
import './styles.scss';

export const CoverExclusions = ({
  definitions,
  brokerId,
  productId,
  brokerType,
  onToggleTest,
}) => {
  const handleToggleTest = (e) => {
    onToggleTest(e.currentTarget.checked);
  };

  const validation = true; // !isEmpty(product.quotes) && size(get(formValues, 'data.relationships.schemes.data', [])) === 1

  const productFilter = `?filter[product]= ${productId}`;
  const isBrokerType = brokerType === 'broker';
  const brokerIdFromForm = brokerId && isBrokerType ? brokerId : undefined;
  const brokerIdFilter = isBroker() ? getBrokerId() : brokerIdFromForm;
  const campaignFilter = brokerIdFilter
    ? productFilter.concat(`&filter[broker]= ${brokerIdFilter}`)
    : productFilter;

  return (
    <div className="cov-exclusions">
      <div className="flex-box-cov-items">
        <div className="flex-item-cov-title">
          <InfoButton content={definitions?.b2b?.exclude_baggage} />

          <span> Exclude Baggage</span>
        </div>
        <div className="flex-item-cov">
          <Field
            name="data.attributes.metadata.options.exclude_baggage"
            component={CovExclCheckbox}
            options={options}
          />
        </div>
      </div>
      <div className="flex-box-cov-items">
        <div className="flex-item-cov-title">
          <InfoButton content={definitions?.b2b?.exclude_cancellation} />

          <span> Exclude Cancellation</span>
        </div>
        <div className="flex-item-cov">
          <Field
            name="data.attributes.metadata.options.exclude_cancellation"
            component={CovExclCheckbox}
            options={options}
          />
        </div>
      </div>
      <div className="flex-box-cov-items">
        <div className="flex-item-cov-title">
          <InfoButton content={definitions?.b2b?.excess_waiver} />

          <span> Excess Waiver</span>
        </div>
        <div className="flex-item-cov">
          <Field
            name="data.attributes.metadata.options.excess_waiver"
            component={CovExclCheckbox}
            options={options}
          />
        </div>
      </div>

      {validation === true ? (
        <div className="select-campaign-box">
          <SelectCampaigns filter={campaignFilter} />
        </div>
      ) : null}
      {hasRole('Superuser (Owner)') && (
        <div className={'toggle-test'}>
          <Field
            name="quoteOnTestSchemes"
            component={CheckboxUnlabeled}
            label={'Test'}
            labelSize={4}
            inline
            options={[{ label: '', value: true }]}
            onChange={handleToggleTest}
          />
        </div>
      )}
    </div>
  );
};

const options = [{ label: 'Send sms?', value: true }];
